<template>
  <Modal class="account-modal" :isOpen="isOpen" :buttons="state.buttons" :title="$t('game.homeView.accountSettings.title')" @close="close()" @callbackBtn1="logout()">
    <template #extra>
      <TabsNavigation :tabs="[$t('game.homeView.accountSettings.buttons.informations'), $t('game.homeView.accountSettings.buttons.deleteAccount')]" @changeTab="(value) => (state.currentTab = value)" />
      <transition mode="out-in" name="fade">
        <component :is="tabsContent[state.currentTab]" />
      </transition>
    </template>
  </Modal>
</template>

<script setup>
import { reactive } from "vue";
import { useCandidateStore } from "@/stores/candidate";
import Informations from "./tabs/Informations.vue";
import DeleteAccount from "./tabs/DeleteAccount.vue";

const { logout } = useCandidateStore();
const { t, locale } = useI18n();

const tabsContent = [Informations, DeleteAccount];

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  language: {
    type: String,
    default: "fr",
  }
});

const state = reactive({
  currentTab: 0,
  buttons: {
    column: false,
    data: [
      {
        label: t("other.actions.logout", {}, { locale: props.language}),
        class: "red icon icon-left",
        icon: "bi-box-arrow-left",
      },
    ],
  },
});

const emits = defineEmits(["close"]);

function close() {
  state.currentTab = 0;
  emits("close");
}
</script>
